module.exports = __webpack_public_path__ + "static/media/money-flow.e3ab3f00.svg";